import { render, staticRenderFns } from "./changeChain.vue?vue&type=template&id=40d10a17&scoped=true&"
import script from "./changeChain.vue?vue&type=script&lang=js&"
export * from "./changeChain.vue?vue&type=script&lang=js&"
import style0 from "./changeChain.vue?vue&type=style&index=0&id=40d10a17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d10a17",
  null
  
)

export default component.exports